Woolman.Utils.prepareQueryParams();
Woolman.Collection = document.querySelector('[data-ajax-parent]');


/* ============================================================
   TAGO'S JUMP
   PRODUCT CARD VARIANT SYNC

   Sincroniza:
   - Foto
   - Precio
   - Compare at price
   - Enlace del producto
   - Variante seleccionada

   Funciona después de:
   - Filtros
   - Sort
   - AJAX
   - Paginación
   ============================================================ */

(function () {

  if (window.__TAGO_CARD_VARIANT_SYNC__) {
    return;
  }

  window.__TAGO_CARD_VARIANT_SYNC__ = true;


  const productCache = new Map();


  function normalizeValue(value) {

    return String(value || '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();

  }


  function getProductHandle(card) {

    if (!card) return null;


    const link =
      card.querySelector('.card-title a[href*="/products/"]') ||
      card.querySelector('a.card-media[href*="/products/"]') ||
      card.querySelector('a[href*="/products/"]');


    if (!link) return null;


    try {

      const url =
        new URL(
          link.href,
          window.location.origin
        );


      const match =
        url.pathname.match(
          /\/products\/([^/?#]+)/
        );


      if (!match || !match[1]) {
        return null;
      }


      return decodeURIComponent(
        match[1]
      );


    } catch (error) {

      return null;

    }

  }


  function getProductURL(handle) {

    let root = '/';


    if (
      window.Shopify &&
      Shopify.routes &&
      Shopify.routes.root
    ) {

      root =
        Shopify.routes.root;

    }


    if (!root.endsWith('/')) {
      root += '/';
    }


    return (
      root +
      'products/' +
      handle
    );

  }


  async function getProduct(handle) {

    if (!handle) {
      return null;
    }


    if (
      productCache.has(handle)
    ) {

      return productCache.get(
        handle
      );

    }


    const promise =
      (async function () {

        try {

          const response =
            await fetch(
              getProductURL(handle) +
              '.js',
              {
                credentials:
                  'same-origin',

                cache:
                  'no-store'
              }
            );


          if (!response.ok) {
            return null;
          }


          return await response.json();


        } catch (error) {

          console.error(
            '[TAGO] Product JSON error:',
            error
          );


          return null;

        }

      })();


    productCache.set(
      handle,
      promise
    );


    return promise;

  }


  function findVariantByOption(
    product,
    optionValue
  ) {

    if (
      !product ||
      !Array.isArray(product.variants)
    ) {

      return null;

    }


    const wanted =
      normalizeValue(
        optionValue
      );


    const matches =
      product.variants.filter(
        function (variant) {

          if (
            !Array.isArray(
              variant.options
            )
          ) {

            return false;

          }


          return variant.options.some(
            function (option) {

              return (
                normalizeValue(option) ===
                wanted
              );

            }
          );

        }
      );


    if (!matches.length) {
      return null;
    }


    /*
      Prioridad:

      1. Disponible + imagen
      2. Imagen
      3. Disponible
      4. Primera coincidencia
    */

    return (

      matches.find(
        function (variant) {

          return (
            variant.available &&
            variant.featured_image &&
            variant.featured_image.src
          );

        }
      )

      ||

      matches.find(
        function (variant) {

          return (
            variant.featured_image &&
            variant.featured_image.src
          );

        }
      )

      ||

      matches.find(
        function (variant) {

          return variant.available;

        }
      )

      ||

      matches[0]

    );

  }


  function findVariantById(
    product,
    variantId
  ) {

    if (
      !product ||
      !Array.isArray(product.variants)
    ) {

      return null;

    }


    return (
      product.variants.find(
        function (variant) {

          return (
            String(variant.id) ===
            String(variantId)
          );

        }
      ) || null
    );

  }


  function getVariantImage(
    variant
  ) {

    if (!variant) {
      return '';
    }


    if (
      variant.featured_image &&
      variant.featured_image.src
    ) {

      return variant
        .featured_image
        .src;

    }


    if (
      variant.featured_media &&
      variant.featured_media.preview_image &&
      variant.featured_media.preview_image.src
    ) {

      return variant
        .featured_media
        .preview_image
        .src;

    }


    return '';

  }


  function updateImageElement(
    image,
    imageURL
  ) {

    if (
      !image ||
      !imageURL
    ) {

      return;

    }


    /*
      Eliminar responsive image anterior.

      Esto evita que el navegador siga
      mostrando la foto del tamaño anterior.
    */

    image.removeAttribute(
      'srcset'
    );

    image.removeAttribute(
      'data-srcset'
    );


    if (
      image.hasAttribute(
        'data-src'
      )
    ) {

      image.setAttribute(
        'data-src',
        imageURL
      );

    }


    const picture =
      image.closest('picture');


    if (picture) {

      picture
        .querySelectorAll('source')
        .forEach(
          function (source) {

            source.removeAttribute(
              'srcset'
            );

            source.removeAttribute(
              'data-srcset'
            );

          }
        );

    }


    image.setAttribute(
      'src',
      imageURL
    );


    image.src =
      imageURL;

  }


  function updateCardImage(
    card,
    variant
  ) {

    const imageURL =
      getVariantImage(
        variant
      );


    if (!imageURL) {
      return;
    }


    const media =
      card.querySelector(
        '.card-media'
      );


    if (!media) {
      return;
    }


    const images =
      media.querySelectorAll(
        'img'
      );


    images.forEach(
      function (image) {

        updateImageElement(
          image,
          imageURL
        );

      }
    );

  }


  /* ============================================================
     PRECIO
     ============================================================ */


  function getCurrencyCode() {

    if (
      window.Shopify &&
      Shopify.currency &&
      Shopify.currency.active
    ) {

      return Shopify
        .currency
        .active;

    }


    return 'USD';

  }


  function formatMoney(cents) {

    const number =
      Number(cents || 0) / 100;


    const currency =
      getCurrencyCode();


    try {

      const formatted =
        new Intl.NumberFormat(
          'en-US',
          {
            style:
              'currency',

            currency:
              currency,

            minimumFractionDigits:
              2,

            maximumFractionDigits:
              2
          }
        ).format(
          number
        );


      /*
        La tienda actualmente muestra:
        $2,900.00 USD
      */

      return (
        formatted +
        ' ' +
        currency
      );


    } catch (error) {

      return (
        '$' +
        number.toFixed(2) +
        ' ' +
        currency
      );

    }

  }


  function updateCardPrice(
    card,
    variant
  ) {

    if (
      !card ||
      !variant
    ) {

      return;

    }


    /*
      Precio normal del tema.
      No dependemos de price-collection.liquid.
    */

    const priceBox =
      card.querySelector(
        '.card-body .price'
      );


    if (!priceBox) {

      console.warn(
        '[TAGO] Price box not found'
      );

      return;

    }


    const price =
      Number(
        variant.price || 0
      );


    const compareAt =
      Number(
        variant.compare_at_price || 0
      );


    const isSale =
      compareAt > price;


    const formattedPrice =
      formatMoney(
        price
      );


    const formattedCompare =
      compareAt > 0
        ? formatMoney(
            compareAt
          )
        : '';


    /*
      Precio regular.
    */

    const regularPrice =
      priceBox.querySelector(
        '.price__regular .price-item'
      );


    if (regularPrice) {

      regularPrice.textContent =
        formattedPrice;

    }


    /*
      Precio de venta.
    */

    const salePrice =
      priceBox.querySelector(
        '.price__sale .price-item--sale'
      );


    if (salePrice) {

      salePrice.textContent =
        formattedPrice;

    }


    /*
      Precio tachado.
    */

    const comparePrice =
      priceBox.querySelector(
        '.price__sale s.price-item--regular'
      ) ||

      priceBox.querySelector(
        '.price__sale .price-item--regular'
      );


    if (comparePrice) {

      comparePrice.textContent =
        formattedCompare;

    }


    /*
      IMPORTANTÍSIMO:

      Shopify mostraba "From $2,900".
      Al cambiar una medida ya sabemos
      la variante exacta.

      Por eso quitamos cualquier "From"
      del elemento que quede visible.
    */

    priceBox
      .querySelectorAll(
        '.price-item'
      )
      .forEach(
        function (element) {

          if (
            element.textContent &&
            element.textContent
              .trim()
              .toLowerCase()
              .startsWith('from ')
          ) {

            element.textContent =
              element.textContent
                .replace(
                  /^\s*from\s+/i,
                  ''
                );

          }

        }
      );


    /*
      Cambiar estado visual del precio.
    */

    priceBox.classList.toggle(
      'price--on-sale',
      isSale
    );


    priceBox.classList.toggle(
      'price--sold-out',
      !variant.available
    );


    priceBox.setAttribute(
      'data-tago-variant-id',
      String(
        variant.id
      )
    );

  }


  /* ============================================================
     LINKS
     ============================================================ */


  function updateCardLinks(
    card,
    handle,
    variant
  ) {

    if (
      !card ||
      !handle ||
      !variant ||
      !variant.id
    ) {

      return;

    }


    const productUrl =
      getProductURL(handle);


    // The card must open the same variant it is currently showing.
    const variantUrl =
      productUrl +
      '?variant=' +
      variant.id;


    card.dataset.tagoInitialVariantId =
      String(variant.id);


    const links =
      card.querySelectorAll(
        'a.card-media, .card-title a'
      );


    links.forEach(
      function (link) {

        link.href =
          variantUrl;

      }
    );


    const quickBuy =
      card.querySelector(
        'quick-buy'
      );


    if (quickBuy) {

      quickBuy.setAttribute(
        'data-url',
        variantUrl
      );

    }

  }


  /* ============================================================
     SIZE BUTTON STATE
     ============================================================ */


  function markSelected(
    option
  ) {

    const group =
      option.closest(
        '.options-availability'
      );


    if (!group) {
      return;
    }


    const promoOption =
      group.querySelector(
        '.variant-option-title[data-tago-fall-promo-option="true"]'
      );

    group
      .querySelectorAll(
        '.variant-option-title'
      )
      .forEach(
        function (button) {

          button.removeAttribute(
            'data-tago-selected'
          );

          button.style.removeProperty(
            'box-shadow'
          );

        }
      );

    /*
      Fall Deals: the black outline identifies the exact promotional size.
      Keep it fixed even if the customer taps another size, so the displayed
      Fall Deal price cannot be visually attributed to the wrong variant.
    */
    if (promoOption) {
      promoOption.setAttribute(
        'data-tago-selected',
        'true'
      );

      promoOption.style.setProperty(
        'box-shadow',
        '0 0 0 2px #202020'
      );

      return;
    }

    option.setAttribute(
      'data-tago-selected',
      'true'
    );

    option.style.setProperty(
      'box-shadow',
      '0 0 0 2px #202020'
    );

  }


  /* ============================================================
     LABELS — OBEY THEME SETTINGS "MOSTRAR EN"
     ============================================================ */

  function getOptionState(option) {
    if (!option) return '';

    const status = normalizeValue(
      option.getAttribute('title') || ''
    );

    if (status.includes('in stock')) return 'in_stock';
    if (status.includes('available soon')) return 'available_soon';
    if (status.includes('made to order')) return 'made_to_order';
    if (status.includes('sold out')) return 'sold_out';

    return '';
  }


  function findOptionForVariant(card, variant) {
    if (!card || !variant) return null;

    const options = Array.from(
      card.querySelectorAll(
        '.options-availability .variant-option-title'
      )
    );

    return (
      options.find(function (option) {
        return String(option.dataset.tagoVariantId || '') === String(variant.id);
      })
      ||
      options.find(function (option) {
        return option.hasAttribute('data-tago-initial-option');
      })
      ||
      null
    );
  }


  function setLabelText(label, text) {
    if (!label) return;

    label.setAttribute('aria-label', text);

    const target =
      label.querySelector('.plabel__text') ||
      label.querySelector('.plabel-sidetab__text') ||
      label.querySelector('.plabel-ribbon span');

    if (target) {
      target.textContent = text;
      return;
    }

    if (label.classList.contains('plabel-banner')) {
      label.textContent = text;
    }
  }


  function syncCardLabels(card, variant, option) {
    if (!card || !variant) return;

    const state = getOptionState(option);
    const price = Number(variant.price || 0);
    const compareAt = Number(variant.compare_at_price || 0);
    const onSale = compareAt > price && compareAt > 0;
    const pct = onSale
      ? Math.floor(((compareAt - price) * 100) / compareAt)
      : 0;
    const saved = onSale
      ? formatMoney(compareAt - price)
      : formatMoney(0);

    const fallStrip = card.querySelector('[data-tago-fall-strip]');
    if (fallStrip) {
      fallStrip.hidden = !onSale;
      fallStrip.classList.toggle('tago-fall-card-strip--hidden', !onSale);
    }

    card
      .querySelectorAll('[data-tago-plabel-rule]')
      .forEach(function (label) {
        const rule = label.getAttribute('data-tago-plabel-rule') || '';
        const labelState = label.getAttribute('data-tago-plabel-state') || '';
        let shouldShow = null;

        if (rule === 'always') {
          shouldShow = true;
        } else if (rule === 'on_sale') {
          shouldShow = onSale;
        } else if (state && rule === 'low_stock') {
          shouldShow = state === 'in_stock';
        } else if (state && rule === 'avs') {
          shouldShow = state === 'available_soon';
        } else if (state && rule === 'sold_out') {
          if (labelState === 'made_to_order') {
            shouldShow = state === 'made_to_order';
          } else if (labelState === 'sold_out') {
            shouldShow = state === 'sold_out';
          } else {
            shouldShow = state === 'made_to_order' || state === 'sold_out';
          }
        }

        if (shouldShow !== null) {
          const hide = !shouldShow;
          label.classList.toggle('tago-plabel-hidden', hide);
          label.hidden = hide;
        }

        const template = label.getAttribute('data-tago-plabel-template');
        if (template) {
          const text = template
            .replace(/\{descuento\}/g, String(pct))
            .replace(/\{ahorro\}/g, String(saved));
          setLabelText(label, text);
        }
      });
  }


  /* ============================================================
     APPLY VARIANT
     ============================================================ */


  function applyVariant(
    card,
    handle,
    variant,
    option
  ) {

    if (
      !card ||
      !variant
    ) {

      return;

    }


    updateCardImage(
      card,
      variant
    );


    updateCardPrice(
      card,
      variant
    );


    updateCardLinks(
      card,
      handle,
      variant
    );


    if (option) {

      markSelected(
        option
      );

    }

    syncCardLabels(
      card,
      variant,
      option || findOptionForVariant(card, variant)
    );

  }


  /* ============================================================
     SIZE CLICK
     ============================================================ */


  async function handleSizeClick(
    option
  ) {

    const card =
      option.closest(
        '.card--product, .card'
      );


    if (!card) {
      return;
    }


    const optionValue =
      String(
        option.textContent || ''
      ).trim();


    if (!optionValue) {
      return;
    }


    const handle =
      getProductHandle(
        card
      );


    if (!handle) {
      return;
    }


    /*
      Evita race condition si se presionan
      18Ft / 20Ft muy rápido.
    */

    const requestToken =
      String(
        Date.now()
      ) +
      '-' +
      Math.random();


    card.dataset
      .tagoVariantRequest =
      requestToken;


    const product =
      await getProduct(
        handle
      );


    if (
      card.dataset
        .tagoVariantRequest !==
      requestToken
    ) {

      return;

    }


    if (!product) {
      return;
    }


    const variant =
      findVariantByOption(
        product,
        optionValue
      );


    if (!variant) {

      console.warn(
        '[TAGO] Variant not found:',
        optionValue,
        handle
      );


      return;

    }


    applyVariant(
      card,
      handle,
      variant,
      option
    );

  }


  /*
    Event delegation.

    Sigue funcionando aunque Shopify
    reemplace la parrilla por AJAX.
  */

  document.addEventListener(
    'click',
    function (event) {

      const option =
        event.target &&
        event.target.closest
          ? event.target.closest(
              '.options-availability .variant-option-title'
            )
          : null;


      if (!option) {
        return;
      }


      handleSizeClick(
        option
      );

    }
  );


  /* ============================================================
     INITIAL PRICE SYNC

     Si card-product ya abrió con:
     ?variant=123456

     hacemos que el precio inicial corresponda
     exactamente con esa variante.
     ============================================================ */


  function getVariantIdFromCard(
    card
  ) {

    if (!card) {
      return '';
    }


    // Primero usar la variante guardada en la tarjeta.
    // Así los enlaces visibles pueden permanecer limpios.
    if (
      card.dataset &&
      card.dataset.tagoInitialVariantId
    ) {

      return String(
        card.dataset.tagoInitialVariantId
      );

    }


    // Compatibilidad: si existe Quick Buy, leer su variante.
    const quickBuy =
      card.querySelector(
        'quick-buy[data-url*="?variant="]'
      );


    if (quickBuy) {

      try {

        const quickBuyUrl =
          new URL(
            quickBuy.getAttribute('data-url'),
            window.location.origin
          );


        const quickBuyVariant =
          quickBuyUrl.searchParams.get(
            'variant'
          );


        if (quickBuyVariant) {
          return quickBuyVariant;
        }

      } catch (error) {
        // Continuar con compatibilidad antigua.
      }

    }


    // Compatibilidad con tarjetas antiguas que todavía
    // tengan ?variant= en el enlace.
    const link =
      card.querySelector(
        '.card-title a[href*="?variant="]'
      ) ||

      card.querySelector(
        'a.card-media[href*="?variant="]'
      );


    if (!link) {
      return '';
    }


    try {

      const url =
        new URL(
          link.href,
          window.location.origin
        );


      return (
        url.searchParams.get(
          'variant'
        ) || ''
      );


    } catch (error) {

      return '';

    }

  }


  async function syncInitialCard(
    card
  ) {

    if (!card) {
      return;
    }


    const variantId =
      getVariantIdFromCard(
        card
      );


    if (!variantId) {

      /*
        Si no tenemos variante en URL,
        dejamos el "From" original.
      */

      return;

    }


    const handle =
      getProductHandle(
        card
      );


    if (!handle) {
      return;
    }


    const product =
      await getProduct(
        handle
      );


    if (!product) {
      return;
    }


    const variant =
      findVariantById(
        product,
        variantId
      );


    if (!variant) {
      return;
    }


    /*
      Al cargar inicialmente actualizamos
      SOLO el precio.

      La imagen ya viene correcta desde Liquid.
    */

    updateCardPrice(
      card,
      variant
    );

    syncCardLabels(
      card,
      variant,
      findOptionForVariant(card, variant)
    );

  }


  function syncAllInitialCards() {

    document
      .querySelectorAll(
        '#product-grid-ajax .card--product, #product-grid-ajax .card'
      )
      .forEach(
        function (card) {

          syncInitialCard(
            card
          );

        }
      );

  }


  function isBackForwardNavigation() {

    try {

      const entries =
        performance.getEntriesByType(
          'navigation'
        );

      return (
        entries &&
        entries.length &&
        entries[0].type ===
          'back_forward'
      );

    } catch (error) {

      return false;

    }

  }


  function runInitialCardSync() {

    /*
      Al volver con la flecha Atrás/Adelante,
      el navegador ya restaura la colección.
      Evitamos volver a procesar todas las tarjetas,
      lo cual puede causar el parpadeo visual.
    */

    if (isBackForwardNavigation()) {
      // Browser bfcache can restore stale product-card prices after a price edit.
      // Re-sync cards from the current product JSON instead of keeping the old DOM.
      productCache.clear();
    }

    syncAllInitialCards();

  }


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      runInitialCardSync,
      {
        once: true
      }
    );

  } else {

    runInitialCardSync();

  }


  window.addEventListener(
    'pageshow',
    function (event) {
      if (event.persisted || isBackForwardNavigation()) {
        productCache.clear();
        setTimeout(syncAllInitialCards, 0);
      }
    }
  );


  document.addEventListener(
    'tago:instock-public-sync',
    function () {

      setTimeout(
        syncAllInitialCards,
        0
      );

    }
  );


  /*
    Dejamos esta función disponible
    para llamarla después de AJAX.
  */

  window.TagoSyncCollectionCardPrices =
    syncAllInitialCards;


})();




/**
 * Generates search params from form data for filtering collection or search results.
 * @param {HTMLElement} formElement
 * @returns
 */

const generateSearchParamsFromFormData =
  (formElement) => {


    const checkboxesToKeep =
      {};


    for (
      const element
      of formElement.elements
    ) {


      const key =
        element.getAttribute(
          'name'
        );


      if (
        !key ||
        !key.includes(
          'filter'
        )
      ) {

        continue;

      }


      const value =
        element.value;


      const inputType =
        element.getAttribute(
          'type'
        );


      if (
        value === ''
      ) {

        continue;

      }


      if (
        inputType == 'number' &&
        (
          element.hasAttribute(
            'data-min'
          ) ||
          element.hasAttribute(
            'data-max'
          )
        )
      ) {


        if (
          !element
            .closest(
              'price-range'
            )
            .hasAttribute(
              'data-updated'
            )
        ) {

          continue;

        }

      }


      if (
        inputType ==
        'checkbox'
      ) {


        if (
          element.checked
        ) {


          if (
            !checkboxesToKeep[
              key
            ]
          ) {

            checkboxesToKeep[
              key
            ] =
              [value];

            continue;

          }


          checkboxesToKeep[
            key
          ].push(
            value
          );


          continue;

        }


        if (
          Shopify
            .queryParams[
              key
            ] &&
          !checkboxesToKeep[
            key
          ]
        ) {


          delete Shopify
            .queryParams[
              key
            ];

        }


        continue;


      } else {


        Shopify
          .queryParams[
            key
          ] =
          value;

      }

    }


    if (
      Object
        .entries(
          checkboxesToKeep
        )
        .length > 0
    ) {


      for (
        const [key, value]
        of Object.entries(
          checkboxesToKeep
        )
      ) {


        Shopify
          .queryParams[
            key
          ] =
          value.join(
            ','
          );

      }

    }


    return Shopify
      .queryParams;

  };




/**
 * Fetch fresh collection page via AJAX.
 */

const getCollectionAJAX =
  async (selectors) => {


    Shopify
      .queryParams
      .page =
      1;


    const CollectionURLSearchParams =
      getCollectionURLSearchParams();


    const url =
      location.pathname +
      '?' +
      CollectionURLSearchParams;


    if (selectors) {


      try {


        const res =
          await fetch(
            url
          );


        const body =
          await res.text();


        const parser =
          new DOMParser();


        const doc =
          parser.parseFromString(
            body,
            'text/html'
          );


        for (
          const selector
          of selectors
        ) {


          if (
            !document
              .querySelector(
                selector
              ) ||
            !doc
              .querySelector(
                selector
              )
          ) {

            continue;

          }


          document
            .querySelector(
              selector
            )
            .innerHTML =
            doc
              .querySelector(
                selector
              )
              .innerHTML;


          if (
            selector ===
            '#product-grid-ajax'
          ) {


            let filteredCount =
              parseInt(
                doc
                  .querySelector(
                    selector
                  )
                  .dataset
                  .filteredCount,
                10
              );


            let context =
              doc
                .querySelector(
                  selector
                )
                .dataset
                .context;


            let zeroResultsMsg =
              document
                .getElementById(
                  'facets-no-results-message'
                );


            let resultsStringOne =
              window
                .themeStrings
                .product_count_simple_one;


            let resultsStringOther =
              window
                .themeStrings
                .product_count_simple_other;


            if (
              context ===
              'search'
            ) {


              resultsStringOne =
                window
                  .themeStrings
                  .results_with_count_one;


              resultsStringOther =
                window
                  .themeStrings
                  .results_with_count_other;

            }


            const applyCount =
              document
                .getElementById(
                  'apply-count'
                );


            if (
              filteredCount ===
              0
            ) {


              if (
                applyCount
              ) {

                applyCount
                  .innerHTML =
                  resultsStringOther
                    .replace(
                      '[count]',
                      filteredCount
                    );

              }


              if (
                zeroResultsMsg
              ) {

                zeroResultsMsg
                  .classList
                  .remove(
                    'hide'
                  );

              }


            } else if (
              filteredCount ===
              1
            ) {


              if (
                applyCount
              ) {

                applyCount
                  .innerHTML =
                  resultsStringOne
                    .replace(
                      '[count]',
                      filteredCount
                    );

              }


              if (
                zeroResultsMsg
              ) {

                zeroResultsMsg
                  .classList
                  .add(
                    'hide'
                  );

              }


            } else {


              if (
                applyCount
              ) {

                applyCount
                  .innerHTML =
                  resultsStringOther
                    .replace(
                      '[count]',
                      filteredCount
                    );

              }


              if (
                zeroResultsMsg
              ) {

                zeroResultsMsg
                  .classList
                  .add(
                    'hide'
                  );

              }

            }

          }

        }


        window.history
          .replaceState(
            '',
            '',
            url
          );


        if (
          Woolman.Collection
        ) {

          Woolman
            .Collection
            .classList
            .remove(
              'processing'
            );

        }


        /*
          IMPORTANTE:
          Shopify acaba de reemplazar tarjetas.
          Volvemos a sincronizar precios.
        */

        if (
          typeof window
            .TagoSyncCollectionCardPrices ===
          'function'
        ) {

          window
            .TagoSyncCollectionCardPrices();

        }


      } catch (err) {


        location.search =
          CollectionURLSearchParams;

      }


    } else {


      location.search =
        CollectionURLSearchParams;

    }

  };




/**
 * Current collection URL parameters
 */

const getCollectionURLSearchParams =
  () => {


    return new URLSearchParams(
      Object.entries(
        Shopify.queryParams
      )
    )
      .toString()
      .replaceAll(
        /%2C/g,
        ','
      );

  };




class SortBySelect
extends HTMLElement {


  constructor() {

    'use strict';

    super();


    this.el =
      this.querySelector(
        'select'
      );


    this.selectors =
      {

        grid:
          '#product-grid-ajax',

        pagination:
          '#pagination-ajax',

      };


    if (
      Shopify
        .queryParams[
          'sort_by'
        ]
    ) {


      this.el.value =
        Shopify
          .queryParams[
            'sort_by'
          ];

    }


    this.el
      .addEventListener(
        'change',
        this
          .onSelectChange
          .bind(this)
      );

  }


  async onSelectChange(
    event
  ) {


    if (
      Woolman.Collection
    ) {

      Woolman
        .Collection
        .classList
        .add(
          'processing'
        );

    }


    Woolman
      .Utils
      .prepareQueryParams();


    const value =
      event
        .target
        .value;


    Shopify
      .queryParams
      .sort_by =
      value;


    getCollectionAJAX(
      Object.values(
        this.selectors
      )
    );

  }

}




if (
  customElements.get(
    'sort-by'
  ) === undefined
) {


  customElements.define(
    'sort-by',
    SortBySelect
  );

}




class FacetsForm
extends HTMLElement {


  constructor() {

    'use strict';

    super();


    this.el =
      this.querySelector(
        'form'
      );


    this.selectors =
      {

        grid:
          '#product-grid-ajax',

        count:
          '#products-count-ajax',

        currentFacets:
          '#current-facets-ajax',

        pagination:
          '#pagination-ajax',

      };


    const inputs =
      this.el
        .querySelectorAll(
          'input'
        );


    inputs.forEach(
      (input) => {


        input
          .addEventListener(
            'change',
            debounce(
              this
                .onCheckboxChanged
                .bind(this),
              150
            )
          );

      }
    );


    this.el
      .addEventListener(
        'submit',
        this
          .onFormSubmit
          .bind(this)
      );

  }


  async onFormSubmit(
    event
  ) {


    event
      .preventDefault();


    if (
      Woolman.Collection
    ) {

      Woolman
        .Collection
        .classList
        .add(
          'processing'
        );

    }


    Woolman
      .Utils
      .prepareQueryParams();


    generateSearchParamsFromFormData(
      this.el
    );


    const drawer =
      this.closest(
        '[data-drawer]'
      );


    if (
      drawer &&
      Woolman
        .ModalsAndDrawers
    ) {


      Woolman
        .ModalsAndDrawers
        .closeModalOrDrawer(
          drawer
            .getAttribute(
              'id'
            )
        );

    }


    getCollectionAJAX(
      Object.values(
        this.selectors
      )
    );

  }


  async onCheckboxChanged() {


    if (
      Woolman.Collection
    ) {

      Woolman
        .Collection
        .classList
        .add(
          'processing'
        );

    }


    generateSearchParamsFromFormData(
      this.el
    );


    getCollectionAJAX(
      Object.values(
        this.selectors
      )
    );

  }

}




if (
  customElements.get(
    'facets-form'
  ) === undefined
) {


  customElements.define(
    'facets-form',
    FacetsForm
  );

}




class CurrentFacetButton
extends HTMLElement {


  constructor() {

    'use strict';

    super();


    this.selectors =
      {

        grid:
          '#product-grid-ajax',

        count:
          '#products-count-ajax',

        currentFacets:
          '#current-facets-ajax',

        pagination:
          '#pagination-ajax',

      };


    this.btn =
      this.querySelector(
        'a'
      );


    if (
      this.btn
    ) {


      this.btn
        .addEventListener(
          'click',
          this
            .removeFacet
            .bind(this)
        );

    }

  }


  async removeFacet(
    event
  ) {


    event
      .preventDefault();


    if (
      event
        .currentTarget
        .dataset
        .filterParamName ===
      'filter.v.price'
    ) {


      const price_slider =
        document
          .querySelector(
            'price-range'
          );


      delete Shopify
        .queryParams[
          'filter.v.price.lte'
        ];


      delete Shopify
        .queryParams[
          'filter.v.price.gte'
        ];


      if (
        price_slider
      ) {


        price_slider
          .dispatchEvent(
            new Event(
              'reset'
            )
          );


        price_slider
          .removeAttribute(
            'data-updated'
          );

      }


      getCollectionAJAX(
        Object.values(
          this.selectors
        )
      );


    } else {


      const filterName =
        event
          .currentTarget
          .dataset
          .filterParamName;


      const filterValue =
        event
          .currentTarget
          .dataset
          .filterValue;


      const inputToReset =
        document
          .querySelector(
            `#facets [data-key-value="${filterName}:${filterValue}"]`
          );


      if (
        inputToReset
      ) {


        inputToReset.checked =
          false;


        inputToReset
          .dispatchEvent(
            new Event(
              'change'
            )
          );

      }

    }

  }

}




if (
  customElements.get(
    'current-facet-button'
  ) === undefined
) {


  customElements.define(
    'current-facet-button',
    CurrentFacetButton
  );

}